import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Users, KeyRound, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Compact user footer used at the bottom of every sidebar.
 * Shows: avatar + username + role (+ organisation if available), a
 * "Change password" link, and a Logout button.
 */
const SidebarUserFooter = ({ user, onLogout, className = '' }) => {
  const { t } = useTranslation();
  if (!user) return null;
  return (
    <div className={`bg-gray-50 rounded-lg p-4 ${className}`} data-testid="sidebar-user-footer">
      <div className="flex items-center space-x-3 mb-3">
        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
          <Users className="h-5 w-5 text-blue-600" />
        </div>
        <div className="min-w-0">
          <p className="font-medium text-gray-900 truncate">{user.username}</p>
          <p className="text-sm text-gray-500 capitalize truncate">
            {String(user.role || '').replace(/_/g, ' ')}
          </p>
          {user.organization_name && (
            <p className="text-xs text-gray-500 truncate">{user.organization_name}</p>
          )}
        </div>
      </div>
      <Link
        to="/change-password"
        className="w-full inline-flex items-center justify-center gap-2 h-9 px-3 mb-2 text-xs font-medium rounded-md border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors"
        data-testid="change-password-link"
      >
        <KeyRound className="h-3.5 w-3.5" />
        {t('common.change_password', 'Change password')}
      </Link>
      <Button
        onClick={onLogout}
        variant="outline"
        size="sm"
        className="w-full"
        data-testid="logout-button"
      >
        <LogOut className="h-4 w-4 mr-2" />
        {t('common.logout', 'Logout')}
      </Button>
    </div>
  );
};

export default SidebarUserFooter;
